import { CANVAS_MIME, type CanvasDocument } from '@orqforge/shared';

export function isCanvasFile(file: { mimeType?: string; filename?: string }): boolean {
  const mime = file.mimeType ?? '';
  const name = file.filename ?? '';
  return mime === CANVAS_MIME || name.endsWith('.canvas.json');
}

export function pickLatestCanvasFile<T extends { mimeType?: string; filename?: string }>(files: T[]): T | undefined {
  const matches = files.filter((f) => isCanvasFile(f));
  return matches.at(-1);
}

/** Two-column Collaborate grid unless the active run published a canvas. */
export function collaborateGridClass(hasCanvas: boolean): string {
  return hasCanvas
    ? 'lg:grid-cols-[280px_minmax(0,1fr)_minmax(300px,0.95fr)]'
    : 'lg:grid-cols-[320px_minmax(0,1fr)]';
}

function decodeBase64Utf8(value: string): string {
  if (typeof Buffer !== 'undefined') return Buffer.from(value, 'base64').toString('utf8');
  const binary = atob(value);
  const bytes = Uint8Array.from(binary, (ch) => ch.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

/** Inline canvas JSON from a data URL or contentBase64. Null means fetch `url`. */
export function readCanvasText(file: { url?: string | null; contentBase64?: string | null }): string | null {
  const inline = String(file.contentBase64 || '').trim();
  if (inline) return decodeBase64Utf8(inline);
  const url = String(file.url || '');
  if (!url.startsWith('data:')) return null;
  const comma = url.indexOf(',');
  if (comma < 0) return null;
  const payload = url.slice(comma + 1);
  const header = url.slice(0, comma);
  return header.includes(';base64') ? decodeBase64Utf8(payload) : decodeURIComponent(payload);
}
